export default (namespace, types = []) => {
  const DefinedTypes = {};
  types.forEach(type => {
    DefinedTypes[type] = `${namespace}/${type}`;
  });
  return DefinedTypes;
};



// WEBPACK FOOTER //
// ./src/helpers/defineTypes.js